import { FC } from 'react';

import { Loading } from '@shared/components/Loading';
import { createPortal } from 'react-dom';

import { ConfirmError } from '../hooks/useTossPaymentResult';

interface PaymentResultOverlayProps {
  isConfirming: boolean;
  confirmError: ConfirmError | null;
  retryCount: number;
  maxRetry: number;
  onRetry: () => void;
  onCancel: () => void;
}

const PaymentResultOverlay: FC<PaymentResultOverlayProps> = ({
  isConfirming,
  confirmError,
  retryCount,
  maxRetry,
  onRetry,
  onCancel,
}) => {
  if (!isConfirming && !confirmError) return null;

  return createPortal(
    <div className="Preed">
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
        <div className="w-full max-w-sm rounded-lg bg-white p-6 shadow-xl">
          {isConfirming ? (
            <>
              <div className="flex items-center justify-center pb-4 pt-2">
                <Loading />
              </div>
              <h3 className="text-center text-lg font-bold">결제 승인 처리 중</h3>
              <p className="mt-2 text-center text-gray-500">잠시만 기다려주세요...</p>
              {retryCount > 0 && (
                <p className="mt-1 text-center text-xs text-gray-400">
                  재시도 {retryCount}/{maxRetry}
                </p>
              )}
            </>
          ) : confirmError ? (
            <>
              <div className="mb-4 flex justify-center">
                <svg
                  className="h-12 w-12 text-red-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h3 className="text-center text-lg font-bold">{confirmError.title}</h3>
              <p className="mt-2 text-center text-sm text-gray-500">
                {confirmError.message}
              </p>
              <div className="mt-6 flex gap-3">
                <button
                  onClick={onCancel}
                  className="flex-1 rounded-lg border border-gray-300 py-3 text-sm font-medium text-gray-700"
                >
                  주문 취소
                </button>
                {confirmError.canRetry && (
                  <button
                    onClick={onRetry}
                    className="flex-1 rounded-lg py-3 text-sm font-medium text-white theme-bg-main"
                  >
                    {retryCount < maxRetry ? '다시 시도' : '새로 결제하기'}
                  </button>
                )}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default PaymentResultOverlay;
